import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { VariableSizeList } from "react-window";
export var VariableSizeListStyled = styled(VariableSizeList)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    & > div {\n        position: relative;\n        margin: 8px 0;\n    }\n"])));
//# sourceMappingURL=VariableSizeListStyled.js.map